import React, { Component } from "react";
import { graphql, compose } from "react-apollo";
import { observable } from "mobx";
import { observer } from "mobx-react";
import TextArea from "./TextArea";
import {
  mutationAddNoteToCustomerInfo,
  queryGetCustomerFromCase
} from "Apollo";
import { ShowNotice } from "Store";

export default compose(
  graphql(queryGetCustomerFromCase),
  graphql(mutationAddNoteToCustomerInfo)
)(
  observer(
    class CustomerNote extends Component {
      states = observable({
        text: "",
        isLoading: false,
        isMutationDone: false,
        initialValue: ""
      });

      componentWillReceiveProps(nextProps) {
        if (this.props.case.id !== nextProps.case.id) {
          nextProps.data.refetch();
          this.states.text = "";
          this.states.initialValue = "";
        }

        const { getCustomerFromCase } = nextProps.data;
        if (getCustomerFromCase && getCustomerFromCase.noteInfo) {
          this.states.text = getCustomerFromCase.noteInfo.content;
          this.states.initialValue = getCustomerFromCase.noteInfo.content;
        } else {
          this.states.text = "";
          this.states.initialValue = "";
        }
      }

      render() {
        return (
          <TextArea
            {...this.props}
            value={this.states.text}
            initialValue={this.states.initialValue}
            onChange={this.onChange}
            onSave={this.onSaveNote}
            isLoading={this.states.isLoading}
            isMutationDone={this.states.isMutationDone}
          />
        );
      }

      onChange = text => {
        this.states.text = text;
      };

      onSaveNote = async () => {
        const customer = this.props.data.getCustomerFromCase;
        if (customer) {
          this.states.isLoading = true;
          try {
            await this.props.mutate({
              variables: {
                customerInput: {
                  id: customer.id
                },
                content: this.states.text
              }
            });
            await this.props.data.refetch();
            ShowNotice("note-save-success");
          } catch (error) {
            ShowNotice("note-save-error");
          }
          this.states.isLoading = false;
          this.states.isMutationDone = true;
          setTimeout(() => {
            this.states.isMutationDone = false;
          }, 1500);
        }
      };
    }
  )
);



// WEBPACK FOOTER //
// ./src/module-case-management/info-panel/CustomerNoteWithQueryMutation.js